import {
    Avatar,
    Box,
    Button,
    Card,
    CardHeader,
    Grid,
    IconButton,
    InputBase,
    Pagination,
    Paper,
    Stack,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTheme } from '@mui/styles';
import SubCard from 'ui-component/cards/SubCard';
import VisibilityIcon from '@mui/icons-material/Visibility';
import StyledDataGrid from 'ui-component/StyledDataGrid';
import axios from 'axios';
import ApiLink from 'API';
import { useNavigate } from 'react-router';
import NumberFormat from 'react-number-format';
import ViewInoice from './ViewInoice';
import moment from 'moment';
import ReactMoment from 'react-moment';
import CoinAoneDark200 from '../../assets/images/CoinAoneDark200.png';
import CoinSamsungDark200 from '../../assets/images/CoinSamsungDark200.png';
import DescriptionIcon from '@mui/icons-material/Description';
import { exportToCSV } from 'ui-component/exportToCSV';
import { useSearchParams } from 'react-router-dom';
export const Invoice = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [openBackdrop, setopenBackdrop] = useState(false);
    const theme = useTheme();
    const [BillData, setBillData] = useState([]);
    const [totalPage, settotalPage] = useState(0);
    const [page, setpage] = useState(1);
    const [total, settotal] = useState(0);
    const navigate = useNavigate();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));
    const [ValueSearch, setValueSearch] = useState('');
    const [OpenInvoice, setOpenInvoice] = useState(false);
    const [DataInvoice, setDataInvoice] = useState({});
    // const [SelectedData, setSelectedData] = useState({});
    const handlePage = (event, value) => {
        setpage(value);
    };
    const columns = [
        // { field: '_id', headerName: 'id', width: 90 },

        {
            field: 'invoiceNumber',
            headerName: 'Invoice Number',
            width: 200,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography
                    variant="button"
                    gutterBottom
                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                >
                    {params.row.invoiceNumber}
                </Typography>
            )
        },
        {
            field: 'customer',
            headerName: 'customer',
            width: 140,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Stack>
                    <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                        {params.row.customerID}
                    </Typography>
                    <Typography variant="caption" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
                        {params.row.customers.customerName}
                    </Typography>
                </Stack>
            )
        },
        // {
        //     field: 'wallet',
        //     headerName: 'Wallet Payment',
        //     width: 150,
        //     // flex: 0.5,
        //     // editable: true,
        //     sortable: false,
        //     filterable: false,
        //     headerAlign: 'center',
        //     align: 'center',
        //     renderCell: (params) => (
        //         <Stack>
        //             <Button
        //                 fullWidth
        //                 startIcon={
        //                     <Avatar alt="Aone Coin" src={CoinAoneDark200} sx={{ width: 20, height: 20, background: 'transparent' }} />
        //                 }
        //             >
        //                 <Typography
        //                     variant="subtitle1"
        //                     sx={{
        //                         color: '#3035BC',
        //                         fontSize: '0.8rem'
        //                     }}
        //                 >
        //                     <NumberFormat
        //                         thousandsGroupStyle="thousand"
        //                         value={params.row.aonewallets !== null ? params.row.aonewallets.totalPayment : 0}
        //                         prefix="₭"
        //                         decimalSeparator="."
        //                         displayType="text"
        //                         type="text"
        //                         thousandSeparator={true}
        //                         allowNegative={true}
        //                     />
        //                 </Typography>
        //             </Button>
        //             {/* <Button
        //                 fullWidth
        //                 startIcon={
        //                     <Avatar alt="Aone Coin" src={CoinSamsungDark200} sx={{ width: 20, height: 20, background: 'transparent' }} />
        //                 }
        //             >
        //                 <Typography
        //                     variant="subtitle1"
        //                     sx={{
        //                         color: '#000',
        //                         fontSize: '0.8rem'
        //                     }}
        //                 >
        //                     <NumberFormat
        //                         thousandsGroupStyle="thousand"
        //                         value={0}
        //                         prefix="₭"
        //                         decimalSeparator="."
        //                         displayType="text"
        //                         type="text"
        //                         thousandSeparator={true}
        //                         allowNegative={true}
        //                     />
        //                 </Typography>
        //             </Button> */}
        //         </Stack>
        //     )
        // },
        {
            field: 'totalPayment',
            headerName: 'Total',
            width: 120,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Typography
                    variant="body1"
                    color="#f57224"
                    style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                >
                    <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={params.row.totalPayment}
                        prefix="₭"
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={true}
                    />
                </Typography>
            )
        },
        // {
        //     field: 'Amount',
        //     headerName: 'Amount',
        //     width: 100,
        //     sortable: false,
        //     filterable: false,
        //     // flex: 0.5,
        //     // editable: true,
        //     headerAlign: 'center',
        //     align: 'center',
        //     renderCell: (params) => (
        //         <Typography
        //             variant="button"
        //             gutterBottom
        //             style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
        //         >
        //             {params.row.stockController.count}
        //         </Typography>
        //     )
        // },
        // {
        //     field: 'totalSalePrice',
        //     headerName: 'totalSalePrice',
        //     width: 120,
        //     sortable: false,
        //     filterable: false,
        //     // flex: 0.5,
        //     // editable: true,
        //     headerAlign: 'center',
        //     align: 'center',
        //     renderCell: (params) => (
        //         <Typography
        //             variant="body1"
        //             color="#f57224"
        //             style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
        //         >
        //             <NumberFormat
        //                 thousandsGroupStyle="thousand"
        //                 value={params.row.stockController.totalSalePrice}
        //                 prefix="₭"
        //                 decimalSeparator="."
        //                 displayType="text"
        //                 type="text"
        //                 thousandSeparator={true}
        //                 allowNegative={true}
        //             />
        //         </Typography>
        //     )
        // },
        {
            field: 'createdAt',
            headerName: 'Date',
            width: 200,
            sortable: false,
            filterable: false,
            // flex: 0.5,
            // editable: true,
            headerAlign: 'center',
            align: 'center',
            // editable: true,
            renderCell: (params) => {
                return (
                    <Typography
                        variant="button"
                        gutterBottom
                        style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize: '0.8rem' }}
                    >
                        {moment(params.row.createdAt).format('DD-MM-yyyy HH:mm')}
                    </Typography>
                );
            }
        },
        // {
        //     field: 'saleBy',
        //     headerName: 'SaleBy',
        //     width: 200,
        //     // flex: 0.5,
        //     // editable: true,
        //     headerAlign: 'center',
        //     align: 'center',
        //     renderCell: (params) => (
        //         <Typography variant="button" gutterBottom style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>
        //             {params.row.saleBy}
        //         </Typography>
        //     )
        // },
        {
            field: 'action',
            headerName: 'Action',
            // flex: 0.5,
            width: 160,
            sortable: false,
            filterable: false,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => (
                <Stack direction="row" spacing={1}>
                    <IconButton
                        disabled={openBackdrop}
                        // color="primary"
                        sx={{ color: '#0c4da2' }}
                        onClick={() => {
                            PreviewInvoice(params.row.invoiceNumber);
                            // setSelectedData(params.row);
                            // setOpenInvoice(true);
                        }}
                    >
                        <VisibilityIcon />
                    </IconButton>
                    <IconButton
                        variant="contained"
                        color="success"
                        onClick={(e) => {
                            ExportExcel(params.row.invoiceNumber);
                            // console.log(params.row);
                            // exportToCSV(params.row.stockController, params.row.invoiceNumber);
                        }}
                    >
                        <DescriptionIcon />
                    </IconButton>
                </Stack>
            )
            // editable: true
        }
    ];
    const ExportExcel = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const Preview = await axios.get(ApiLink + '/api/aonewallet/invoice/' + Requestid, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (Preview.status === 200) {
                exportToCSV(Preview.data?.data?.stockController, Requestid);
                // setDataInvoice(Preview.data?.data);
                // setOpenInvoice(true);
                // console.log(Preview.data.data);
                // const Content = await (<InvoicePDF data={Preview.data?.data} />);
                // MessageBox.open({
                //     title: 'Preview',
                //     content: Content,
                //     buttons: [{ name: 'Close', handler: () => true }]
                // });
            } else if (Preview.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
            console.log(error);
        }
        setopenBackdrop(false);
    };
    const PreviewInvoice = async (Requestid) => {
        try {
            setopenBackdrop(true);
            const Preview = await axios.get(ApiLink + '/api/aonewallet/invoice/' + Requestid, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (Preview.status === 200) {
                setDataInvoice(Preview.data?.data);
                setOpenInvoice(true);
                // console.log(Preview.data.data);
                // const Content = await (<InvoicePDF data={Preview.data?.data} />);
                // MessageBox.open({
                //     title: 'Preview',
                //     content: Content,
                //     buttons: [{ name: 'Close', handler: () => true }]
                // });
            } else if (Preview.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.clear();
                navigate(0);
            }
            console.log(error);
        }
        setopenBackdrop(false);
    };
    async function LoadData(ValueFind) {
        try {
            setBillData([]);
            setopenBackdrop(true);
            const valueReplate = ValueFind === '' ? '^' : ValueFind.toLowerCase();

            const response = await axios.get(ApiLink + '/api/billing/invoice/withoutdetail/' + valueReplate + '/' + page, {
                withCredentials: true,
                headers: {
                    token: localStorage.getItem('token')
                }
            });
            if (response.status === 200) {
                setBillData(response.data.data);
                settotal(response.data.total);
                settotalPage(response.data.totalPage);
                setopenBackdrop(false);
            } else if (response.status === 401) {
                //got to login and clear token
                localStorage.clear();
                navigate(0);
            }
        } catch (error) {
            console.log(error);
            if (error.response.status === 401) {
                localStorage.clear();
                navigate(0);
            }
        }
    }
    // useEffect(() => {
    //     LoadData(ValueSearch);
    // }, []);
    useEffect(() => {
        if (searchParams.get('invoiceNumber') !== null) {
            console.log(searchParams.get('invoiceNumber'));
            setValueSearch(searchParams.get('invoiceNumber'));
            LoadData(searchParams.get('invoiceNumber'));
        } else {
            LoadData(ValueSearch);
        }
        //LoadData(ValueSearch);
    }, [page]);
    return (
        // <MainCard>
        <Grid container spacing={2}>
            <ViewInoice Open={OpenInvoice} setOpen={setOpenInvoice} DataInvoice={DataInvoice} />
            <Grid item xs={12}>
                <SubCard
                    title="Invoice List"
                    contentSX={{ p: 0 }}
                    show={true}
                    secondary={
                        <Paper style={{ display: 'flex', width: matchDownSM ? 180 : 300 }} elevation={2}>
                            <InputBase
                                type="text"
                                fullWidth
                                disabled={openBackdrop}
                                style={{
                                    marginLeft: 1,
                                    flex: 1,
                                    fontFamily: 'boonhome-400'
                                }}
                                value={ValueSearch}
                                onChange={(event) => {
                                    setValueSearch(event.target.value);
                                }}
                                onKeyDown={(e) => {
                                    if (e.keyCode == 13) {
                                        setpage(1);
                                        LoadData(ValueSearch);
                                    }
                                }}
                                placeholder="Invoice Number"
                                inputProps={{ 'aria-label': 'Invoice Number' }}
                                endAdornment={
                                    <IconButton
                                        disabled={openBackdrop}
                                        className="iconbutton"
                                        aria-label="search"
                                        onClick={(e) => {
                                            setpage(1);
                                            LoadData(ValueSearch);
                                        }}
                                    >
                                        <SearchIcon />
                                    </IconButton>
                                }
                                startAdornment={
                                    <IconButton
                                        disabled={openBackdrop}
                                        className="iconbutton"
                                        aria-label="refresh"
                                        onClick={() => {
                                            // setData(dataOriginal);
                                            setValueSearch('');
                                            LoadData('');
                                        }}
                                    >
                                        <RefreshIcon />
                                    </IconButton>
                                }
                            />
                        </Paper>
                    }
                >
                    <Box
                        // style={{
                        //     width: '100%',
                        //     height: '80vh',
                        //     textAlign: 'center'
                        //     // overflow: "auto",
                        // }}
                        sx={{ width: '100%', height: '80vh', textAlign: 'center', border: 0, borderRadius: 16 }}
                    >
                        <StyledDataGrid
                            loading={openBackdrop}
                            getRowId={(row) => row._id}
                            rows={BillData}
                            columns={columns}
                            //pageSize={20}
                            rowHeight={100}
                            headerHeight={60}
                            hideFooter={true}
                        />
                    </Box>
                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '5px'
                        }}
                    >
                        <Pagination
                            disabled={openBackdrop}
                            count={totalPage}
                            // variant="outlined"
                            page={page}
                            size="small"
                            shape="rounded"
                            color="primary"
                            onChange={handlePage}
                            showFirstButton
                            showLastButton
                        />
                    </Box>
                    <p
                        style={{
                            fontSize: '10px',
                            display: 'flex',
                            justifyContent: 'center',
                            paddingTop: '5px'
                        }}
                    >
                        Total : {total}
                    </p>
                </SubCard>
            </Grid>
        </Grid>
        // </MainCard>
    );
};
